import { Component, OnInit, Input } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';
import { Its2RequestSearchResult } from '@common/models/search-result';
import { ISearchCategory } from '@apps/root/root.constants';
import { Request } from '@apps/its2/domain/models/request';

import { SearchCategory } from './search-category';

@Component({
    selector: 'aa-its2-request-search-category',
    templateUrl: './search-category.component.html',
    styleUrls: [
        './search-category.component.scss'
    ],
    standalone: false
})
export class Its2RequestSearchCategoryComponent extends SearchCategory<Request> implements OnInit
{
    @Input() category: ISearchCategory;
    public results: Observable<Its2RequestSearchResult[]> = of([]);

    constructor (private store: Store<IAuroraState>)
    {
        super();
    }

    ngOnInit ()
    {
        this.results = this.store
            .pipe(
                select(fromRootStore.getIts2RequestsSearchResults)
            );
    }
}
